import { defineNuxtPlugin } from "nuxt/app";
import * as Sentry from "@sentry/nuxt";
import { makeFetchTransport } from "@sentry/nuxt";

import { NUXT_SENTRY_URL, NUXT_SENRTY } from "~/types/env";

export default defineNuxtPlugin(async (nuxtApp) => {
  // 是否上报: NUXT_SENRTY

  if (!NUXT_SENRTY) return;
  // const customTransport = (options) => {
  //   return makeFetchTransport(
  //     {
  //       ...options,
  //       headers: {
  //         ...options.headers,
  //         // Authorization:
  //         //   "Bearer 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",
  //       },
  //     },
  //     options.fetch
  //   );
  // };
  Sentry.init({
    dsn: NUXT_SENTRY_URL,
    tracesSampleRate: 1.0,
    // integrations: [
    //   new BrowserTracing({
    //     tracingOrigins: ["localhost", "192.168.3.25", /^\//],
    //   }),
    // ],
    // transport: (options) => customTransport(options),
  });

  nuxtApp.vueApp.$sentry = Sentry;
});
